import AccountModal from '@/pages/AccountModal';
import NewTermsDialog from '@/components/core/NewTermsDialog';
import HowToPlayModal from '@/pages/HowToPlayModal';
import HiatusModal from '@/components/lobby-details/lobby-common-popus/HiatusModal';
import MilestoneModal from '@/components/lobby-details/lobby-common-popus/MilestoneModal';
import CrowdLockIntroModal from '@/components/events/CrowdLockIntroModal';
import SmartRatingCelebratory from '@/components/lobby-details/SmartRatingCelebratory';
// import IntroVideoDialog from '@/components/core/IntroVideoDialog';
// import NewFeatureUserInsightPopup from '@/components/core/NewFeatureUserInsightPopup';
import { AuthModal } from '@/components/auth/modals/auth.modal';
import { UsersDto } from '@sportspredict/shared';
import type { Achievement } from '@/types/layout.types';

interface LayoutModalsProps {
	accountOpen: boolean;
	onAccountChange: (open: boolean) => void;
	howToOpen: boolean;
	onHowToChange: (open: boolean) => void;
	showHiatusModal: boolean;
	onHiatusClose: () => void;
	showMilestoneModal: boolean;
	onMilestoneClose: () => Promise<void>;
	pendingAchievement: Achievement | null;
	user: UsersDto | null | undefined;
	termsAccepted: boolean;
	showCrowdLockModal: boolean;
	onCrowdLockClose: () => void;
	popupCategories: string[];
	onPopupCategoriesChange: (categories: string[]) => void;
	setSidebarOpen: (open: boolean) => void;
	authModalOpen: boolean;
	onAuthModalChange: (open: boolean) => void;
}

export function LayoutModals({
	accountOpen,
	onAccountChange,
	howToOpen,
	onHowToChange,
	showHiatusModal,
	onHiatusClose,
	showMilestoneModal,
	onMilestoneClose,
	pendingAchievement,
	user,
	termsAccepted,
	showCrowdLockModal,
	onCrowdLockClose,
	popupCategories,
	onPopupCategoriesChange,
	setSidebarOpen,
	authModalOpen,
	onAuthModalChange,
}: LayoutModalsProps) {
	return (
		<>
			{user && (
				<>
					<AccountModal
						open={accountOpen}
						onOpenChange={onAccountChange}
						setSidebarOpen={setSidebarOpen}
						user={user}
					/>

					{termsAccepted && (
						<>
							<HiatusModal
								open={showHiatusModal}
								onClose={onHiatusClose}
								playerName={user.full_name || ''}
							/>

							<MilestoneModal
								open={showMilestoneModal}
								onClose={onMilestoneClose}
								milestone={pendingAchievement?.type}
								milestoneDetails={pendingAchievement?.details}
							/>

							{popupCategories.length > 0 && (
								<SmartRatingCelebratory
									key={popupCategories[0]}
									open
									categoryId={popupCategories[0]}
									onClose={() => {
										onPopupCategoriesChange([]);
									}}
								/>
							)}
						</>
					)}

					{/*{!isProbabilityEventPage && <IntroVideoDialog user={user} />}*/}

					{user && <NewTermsDialog user={user} />}

					{/*{user.role === UserRole.User && !isProbabilityEventPage && (*/}
					{/*	<NewFeatureUserInsightPopup isHiatusModalOpen={showHiatusModal} user={user} />*/}
					{/*)}*/}
				</>
			)}

			<AuthModal open={authModalOpen} onOpenChange={onAuthModalChange} />

			<HowToPlayModal open={howToOpen} onOpenChange={onHowToChange} />

			<CrowdLockIntroModal open={showCrowdLockModal} onClose={onCrowdLockClose} />
		</>
	);
}
